import { createRoute } from '@tanstack/react-router';

import { termsPageLoadable } from 'pages/terms-page';

import { rootRoute } from '../root';

export const TermsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/terms',
  component: termsPageLoadable,
});
